<template>
<ul class="related-props">
  <li v-for="(item, ii) in value">
    <button class="btn btn-danger" @click.prevent="removeItem(ii)">
      <i :class="'fas fa-xmark'"></i>
    </button>
    <label>{{ item.type?.title }}</label>
<!--     <DataForm :params="{type}" :item="item" /> -->
    <FormSelectCustom :options="propOpts(item.type)" v-model="item.typeValue" v-model:customValue="item.value" />
  </li>
  <li class="new">
    <FormSelect :options="targetItems" v-model="newItemId" @update:modelValue="addNew" />
  </li>
</ul>
</template>

<script>
import api from '@/Util/api';
export default {
  props: ["modelValue", "field", "item", "field", "dbfield"],
  data: ()=>({
    value: [],
    targetItems: [],
    newItemId: null,
  }),
  watch: {
    value: {
      handler() {
        this.$emit("update:modelValue", this.value);
      },
    },
    modelValue: {
      handler() {
        this.value=this.modelValue || [];
      }, immediate: true,
    },
    "item.categories": {
      handler() {
        this.autoAddCategoryProps();
      }, deep: true,
    },
  },
  computed: {
    type() {
      return this.dbfield.target;
    },
    fieldDesc() {
      return this.stores.auth.typeDesc?.[this.type] ?? {};
    },
  },
  methods: {
    propOpts(itemType) {
      var result=(itemType?.values || []).map(item=>({
        value: item.uuid,
        text: item.value
      }));
      return result;
    },
    async loadTargetItems() {
      var where=[];
      var targetClass=this.fieldDesc?.type?.target;
      this.targetItems=(await api.list(targetClass, where, "{uuid,title,values{uuid,value}}", null, 20)).map(item=>({
        text: item.title,
        value: item.uuid,
        type: item,
      }));
    },
    createLink(type) {
      return {
        name: "page",
        params: {
          path: [...this.$route.params.path, type],
        }
      }
    },
    addNew() {
      var newItem={};
      for(var field in this.fieldDesc) {
        if (field!=this.dbfield.name)
          newItem[field]=null;
      }
      var targetItem=this.targetItems.find(item=>item.value==this.newItemId);
      if (targetItem?.type)
        newItem.type=targetItem.type;
      this.value.push(newItem);
      this.$nextTick(()=>
        this.newItemId=null);
    },
    removeItem(index) {
      this.value.splice(index, 1);
    },
    autoAddCategoryProps() {
      for(var category of this.item?.categories || []) {
        for(var property of category?.category?.properties || []) {
          var prop=property.property;
          if (prop) {
            var found=false;
            for(var addedProp of this.modelValue)
              if (addedProp.type?.uuid==prop.uuid)
                found=true;
            if (!found) {
              this.newItemId=prop.uuid;
              this.addNew();
            }
          }
        }
      }
    },
  },
  mounted() {
    this.autoAddCategoryProps();
    this.loadTargetItems();
  },
}
</script>
